var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title__textFont"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"title__background"})])
}
var staticRenderFns = []

export { render, staticRenderFns }